import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthService} from "./services/auth.service";
import {RepoService} from "./services/repo.service";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'MerAppAdminItsu';
  authService = inject(AuthService);
  repo = inject(RepoService);

  ngOnInit() {
    this.authService.initAuthState();
  }
}
